/** Renders a per-axis score breakdown as a two-column label/value grid.
 *
 * The DOM shape and CSS classes (``.breakdown`` / ``.bd-label`` /
 * ``.bd-value``) were defined inline in three call sites — extract here to
 * keep the visual contract single-sourced.
 *
 * Negative numeric values get the ``.negative`` modifier on the value cell
 * so penalty axes (``no_go_penalty``, etc.) read as red.
 */
export function BreakdownGrid({
  breakdown,
}: {
  breakdown: Record<string, number | string> | null | undefined;
}) {
  if (!breakdown || Object.keys(breakdown).length === 0) return null;
  return (
    <div className="breakdown">
      {Object.entries(breakdown).map(([key, value]) => {
        const negative = typeof value === "number" && value < 0;
        return (
          <span key={key} style={{ display: "contents" }}>
            <span className="bd-label">{key}</span>
            <span className={"bd-value" + (negative ? " negative" : "")}>
              {value}
            </span>
          </span>
        );
      })}
    </div>
  );
}
